import { render } from "@wordpress/element";
import UseCaseSidebar from "./components/UseCaseSidebar";

import { BrowserRouter as Router } from "react-router-dom";

export default function View() {
	return (
			<UseCaseSidebar />
	);
}

render(
	<React.StrictMode>
		<View />
	</React.StrictMode>,
	document.getElementById("skilltype_use_cases_sidebar_block")
);
